// extracted by mini-css-extract-plugin
module.exports = {"cardBody":"CardBody_cardBody__3jsn5"};